import { IObservable, Subject } from '~/rage/utils';
import { HelpModalConfig, IHelpModalService } from './helpModalServiceTypes';

export class HelpModalServiceStub implements IHelpModalService {
	private activeModal = new Subject<HelpModalConfig | null>({
		id: 'stub-modal-id',
		title: 'Какая-то система',
		text: 'В общем и целом, тут должно быть этакое краткое описание механики, которую игрок попадает... или нет',
		imageIds: ['image_1', 'image_2', 'image_3'],
	});

	public getActiveModal(): IObservable<HelpModalConfig | null> {
		return this.activeModal;
	}

	public async replyToHelpModal(dontShowAgain: boolean): Promise<void> {
		console.log('helpModal:replyToHelpModal', dontShowAgain);
	}

	public isUnseen(_modalId: string): boolean {
		return true;
	}

	public maskSeen(modalId: string): void {
		console.log('helpModal:maskSeen', { modalId });
	}
}
